module.exports = __webpack_public_path__ + "media/components/src/assets/images/footer-logo/footer-logo-ad1cac9ab99a62c2609d4c7e2b76f486.svg";